import cookie from "js-cookie";
import { useEffect } from "react";
import { Outlet } from "react-router-dom";
import { useAppDispatch } from "store/hooks";
import { resetAuthSlice } from "store/slices/auth.slice";
import { resetCardSlice } from "store/slices/card.slice";
import { resetListSlice } from "store/slices/list.slice";
import {
  resetTransactionsSlice,
  resetUpdateUser,
} from "store/slices/transactions.slice";
const ProtectedBack = () => {
  const dispatch = useAppDispatch();
  useEffect(() => {
    localStorage.removeItem("accessToken");
    cookie.remove("clientId");
    dispatch(resetAuthSlice());
    dispatch(resetCardSlice());
    dispatch(resetListSlice());
    dispatch(resetTransactionsSlice());
    dispatch(resetUpdateUser());
  }, []);

  return (
    <div>
      <Outlet />
    </div>
  );
};

export default ProtectedBack;
